export const setItem = (key: string, payload: any) => {
  return localStorage.setItem(key, JSON.stringify(payload));
};

export const getItem = (key: string) => {
  const item = localStorage.getItem(key);
  if (!item) return null;
  return JSON.parse(item);
};

export const removeItem = (key: string) => {
  localStorage.removeItem(key);
};
